<template>
  <div class="container">
    <div class="header-box">
      <home-top></home-top>
    </div>
    <div class="content-box">
      <!-- 轮播图 -->
      <div class="unfold">
        <!-- 产品展示--纵向 -->
        <div class="directionFrame">
          <div class="mainChildHeader">
            <div class="mainChildBg"></div>
            <div class="mainChildContent">
              <div class="mainChildContentChild1">
                <span>{{ mainChildContent }}</span>
              </div>
              <div class="mainChildContentChild2">
                <span>{{ mainChildContentEg }}</span>
              </div>
            </div>
            <div class="mainChildBg"></div>
          </div>
          <!-- 纵向内容 -->
          <div class="productFrame">
            <div class="product-img" >
              <img src="../assets/appjj.jpg" class="p-img" alt="暂无内容">
            </div>
          </div>
        </div>
        <!-- 产品展示--纵向 -->
        <div class="directionFrame">
          <div class="mainChildHeader">
            <div class="mainChildBg"></div>
            <div class="mainChildContent">
              <div class="mainChildContentChild1">
                <span>内容展示</span>
              </div>
              <div class="mainChildContentChild2">
                <span>CONTENT DISPLAY</span>
              </div>
            </div>
            <div class="mainChildBg"></div>
          </div>
          <!-- 纵向内容 -->
          <div class="productFrame">
            <div class="product-img">
              <img src="../assets/app.jpg" class="p-img" alt="暂无内容">
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="footer-box">
      <home-bottom></home-bottom>
    </div>
  </div>
</template>


<script>
import swiper from "../assembly/swiper.vue"
import homeTop from '../assembly/homeTop.vue'
import homeBottom from '../assembly/homeBottom.vue'
import { getHome } from "../api/home.js"
export default {
  data() {
    return {
      swiperSetting: {
        direction: "horizontal"
      },
      slideArray: [],
      mainChildContent: "E法通APP介绍",
      mainChildContentEg: "E法通APP INTRODUCE",
      productArrayList: [],
      commoitdyArray0: [],
      commoitdyArray1: [],
      commoitdyArray2: []
    }
  },
  methods: {

  },
  components: {
    homeTop,
    swiper,
    homeBottom,
  },
  created() {
    let param = 2
    getHome({ modelId: param }).then((res) => {
      console.log(res.data)
      res.data.forEach((item) => {
        if (item.titleType == 1 && item.titleSort == 1) {
          // 列表赋值
          this.productArrayList = item.fileList
        } else if (item.titleType == 0) {
          // 轮播图赋值
          item.fileList.forEach((res) => {
            this.slideArray.push({
              url: res.filePath
            })
          })
        } else if (item.titleType == 1 && item.titleName == "商品图1") {
          // 商品图赋值
          item.fileList.forEach((res) => {
            this.commoitdyArray0.push({
              url: res.filePath
            })
          })
        } else if (item.titleType == 1 && item.titleName == "商品图2") {
          item.fileList.forEach((res) => {
            this.commoitdyArray1.push({
              url: res.filePath
            })
          })
        } else if (item.titleType == 1 && item.titleName == "商品图3") {
          item.fileList.forEach((res) => {
            this.commoitdyArray2.push({
              url: res.filePath
            })
          })
        }
      })
    })
  }
}
</script>

<style lang="scss" scoped>
.container {
  box-sizing: border-box;
  width: 100%;
  padding: 0;
  margin: 0;
  background-color: rgb(241, 241, 241);
}

.header-box {
  height: 85px;
  width: 100%;
}

.content-box {
  box-sizing: border-box;
  width: 100%;

  .rotationFrame {
    height: 92vh;
    width: 100%;

    // swiper 轮播图
    .sAstyle {
      height: 100%;
      width: 100%;
      margin-left: auto;
      margin-right: auto;
      position: relative;
      overflow: hidden;
      z-index: 1;
    }
  }

  //
  .unfold {
    width: 100%;
    padding-top: 40px;

    .directionFrame {
      box-sizing: border-box;
      width: 100%;

      .mainChildHeader {
        height: 8rem;
        width: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;

      }

      .mainChildBg {
        height: 40%;
        width: 38%;
        background-color: #7B0000;
      }

      .mainChildContent {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        color: #7B0000;
      }

      .mainChildContentChild1 {
        font-size: 3rem;
        font-weight: bold;
      }

      .mainChildContentChild2 {
        margin-top: 0.1rem;
      }

      .productFrame {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;

        .product-img {
          padding: 40px 0;
          width: 60%;

          .p-img {
            width: 100%;
            height: auto;
          }
        }
      }
    }

    .broadwiseFrame {
      box-sizing: border-box;
      width: 100%;

      .mainChildHeader {
        height: 8rem;
        width: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;

      }

      .mainChildBg {
        height: 40%;
        width: 38%;
        background-color: #7B0000;
      }

      .mainChildContent {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        color: #7B0000;
      }

      .mainChildContentChild1 {
        font-size: 3rem;
        font-weight: bold;
      }

      .mainChildContentChild2 {
        margin-top: 0.1rem;
      }


      //
      .productFrame-list {
        display: flex;
        flex-direction: column;
        align-items: center;
        padding: 20px;

        .listFlex {
          box-sizing: border-box;
          width: 62%;
          padding: 20px 30px;
          display: flex;
          justify-content: center;
          background-color: #E8E8E8;
          margin: 30px;

          .flex-item {
            display: flex;
            justify-content: center;
            padding: 60px;
          }


          .listImg {
            height: 260px;
            width: 280px;
          }
        }
      }

    }
  }

}


.footer-box {
  box-sizing: border-box;
  height: 300px;
  width: 100%;
  bottom: 0;
  z-index: 999;
}
</style>



// WEBPACK FOOTER //
// src/components/appIntroduce.vue